import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { QueryKeys, useDelete, useList, UseListParams } from '../../shared';
import { closedDaysClient } from '../clients';
import { IClosedDay, IClosedDayQuery, ISaveClosedDays } from '../models';

const client = closedDaysClient;
const listKey = QueryKeys.ClosedDays;

export function useClosedDaysList(...args: UseListParams<IClosedDay, IClosedDayQuery>) {
    return useList(client, listKey, ...args);
}

export function useCreateClosedDays() {
    const queryClient = useQueryClient();
    return useMutation<IClosedDay[], AxiosError, ISaveClosedDays>({
        mutationFn: (item) => client.createClosedDays(item),
        onSuccess: async (_, { confirmDeletePlanningEntries }) => {
            await queryClient.invalidateQueries({ queryKey: [listKey] });
            // Planning entries on the closed days were deleted and the FEAD amounts redivided
            if (confirmDeletePlanningEntries) {
                await queryClient.invalidateQueries({ queryKey: [QueryKeys.Planning] });
                await queryClient.invalidateQueries({ queryKey: [QueryKeys.FeadDelivery] });
                await queryClient.invalidateQueries({ queryKey: [QueryKeys.Dashboard] });
                await queryClient.invalidateQueries({ queryKey: [QueryKeys.ShipmentProgresses] });
            }
        },
    });
}

export function useDeleteClosedDay() {
    return useDelete(client, listKey);
}
